export default "__VITE_ASSET__RR3ddaAn__"